import React, { Fragment } from 'react';
import AddBoxIcon from '@material-ui/icons/AddBox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';

const ReactTableActionsMedics = ({ data,id_estudio, id_tercero,listForbiddenMedicines}) => {

  const addForbiddenMedicineimiento = async (medicamento) => {

    let dataForbiddenMedicine = 
    {
        id_estudio:parseInt(id_estudio),
        id_tercero:parseInt(id_tercero),
        medicamento:medicamento,
        estado:1,
    }
    await fetch(`${process.env.REACT_APP_PUBLIC_URL}mediproh/create`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Bearer ' + sessionStorage.getItem('token'),
        },
        body: JSON.stringify(dataForbiddenMedicine)
    }).then(response => {
        response.json();
    }).then(data => {
      listForbiddenMedicines();
    }).catch(err => {
      listForbiddenMedicines();
    });
}

  return (<Fragment>
    <td role="cell">
      <Tooltip title="Agregar">
        <IconButton onClick={() => {
          addForbiddenMedicineimiento(data.data.original.principioactivo);
        }}>
          <AddBoxIcon />
        </IconButton>
      </Tooltip>
    </td>
  </Fragment>)
}

export default ReactTableActionsMedics;